// extracted by mini-css-extract-plugin
export default {"StandAloneLayout":"StandAloneLayout__nT+HF","footerWrapper":"footerWrapper__Azom8"};